import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { trackCreateOrRepublishAdButton } from '@/utils/tracking';

interface PublishFormButtonProps {
    actionPath: string;
    csrfMicroServiceToken: string;
}

export const PublishFormButton = ({ actionPath, csrfMicroServiceToken }: PublishFormButtonProps) => {
    const [loading, setLoading] = useState(false);

    return (
        <form action={actionPath} method={'POST'}>
            <input type="hidden" name="adType" value="realestate-letting" />
            <input type="hidden" name="__csrf_token" value={csrfMicroServiceToken} />
            <Button
                onClick={() => {
                    setLoading(true);
                    trackCreateOrRepublishAdButton('finn', null, true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 10000);
                }}
                data-post-button
                loading={loading}
                fullWidth
                type="submit">
                Ny annonse på FINN
            </Button>
        </form>
    );
};
